module.exports = __webpack_public_path__ + "static/media/self_study_reg.73833eef.png";